<template>
 
  <basepage
    title="Coper Resmi Muhasebe Entegrasyonu"
    :status="status"
    :menuitems="menuItems"
    v-on:menuclick="menuClick"
  >
    <template slot="toolbar">
      <!--
    <v-text-field v-model="aranacak" flat="" solo-inverted="" hide-details :label="this.$t('Search')" append-icon="search"></v-text-field>
    <v-btn :disabled="status.loading" flat @click="kayitgetir()">Ara</v-btn>
    -->
    </template>
   
    <v-layout v-if="StatusUI.buttonBaslat">
      <v-flex xs12 sm6 offset-sm3>
        <v-card>
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">Entegrasyon Seçenekleri</h3>
             
            </div>
          </v-card-title>
<v-layout>
 
</v-layout>
          <v-layout row wrap>
            <!-- <v-layout row wrap>
                <v-flex xs12 sm6 md6>
                  <v-select
                        :items="this.credentials.Sirketler"
                        item-text="SirketAdi"
                        item-value="SirketKodu"
                        label="Cari Firması"
                        v-model="seciliCariFirma"
                        :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                      ></v-select> 
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-select
                        :items="this.credentials.MuhasebeSirketler"
                        item-text="CompanyShortName"
                        item-value="CompanyID"
                        label="Muhasebe Firması"
                        v-model="seciliMuhasebeFirma"
                        :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                      ></v-select> 
                </v-flex>
              </v-layout> -->
            <v-flex xs12 sm6 md6>
              <merkez
                ref="merkezcmp"
                v-model="CenterCode"
                :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                :isCoper="true"
                :coperDate="prm.Tarih1"
               
              >
              </merkez>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <fistipi
                v-model="RecieptType"
                :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                :coperDate="prm.Tarih1"
                :isCoper="true"
              ></fistipi>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs12 sm6 md6>
              <tarihcomp
                :etiket="$t('Starting-Date')"
                :detaygizle="false"
                v-model="prm.Tarih1"
                v-bind:defaultvalue="'ok'"
                :rules="[(v) => !!v || $t('Please-select-a-date')]"
                @input="up"
              ></tarihcomp>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <tarihcomp
                :etiket="$t('Finishing-Date')"
                :detaygizle="false"
                v-model="prm.Tarih2"
                v-bind:defaultvalue="'ok'"
                :rules="[(v) => !!v || $t('Please-select-a-date')]"
              ></tarihcomp>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Fatura Seri"
                v-model="prm.SeriNo"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field
                type="number"
                label="Fatura No"
                v-model="prm.FaturaNo"
              ></v-text-field>
            </v-flex>
          </v-layout>


          <v-layout row wrap>
            <v-flex xs12 sm6 md6>
              <genelarama apiname="MasrafMerkeziAra" :label="this.$t('Expense-Center')" v-model="MasrafMerkezi"> </genelarama>
            </v-flex>
            
          </v-layout>


          <div>
            <v-checkbox
              v-model="prm.FaturaTipleri.Satis"
              label="Giden - Satış Faturası"
            ></v-checkbox>
            <v-checkbox
              v-model="prm.FaturaTipleri.Komisyon"
              label="Giden - Komisyon Faturası"
            ></v-checkbox>
            <v-checkbox
              v-model="prm.FaturaTipleri.Iade"
              label="Giden - Alış Iade Faturası"
            ></v-checkbox>
            <v-checkbox
              v-model="prm.FaturaTipleri.Gelen"
              label="Gelen - Alış Faturası"
            ></v-checkbox>
            <v-checkbox
              v-model="prm.FaturaTipleri.SatisIadesi"
              label="Gelen - Satış Iade Faturası"
            ></v-checkbox>
          </div>

          <div v-if="StatusUI.hataOlustu">
            <span style="color: red"
              >{{ $t("Error") }} : {{ StatusUI.aciklama }}</span
            >
            <code>
              {{ StatusUI.hataMesaji }}
            </code>
          </div>
          <div v-else>
            <div>
              <span style="color: orange"> {{ StatusUI.aciklama }}</span>
            </div>
          </div>

          <v-card-actions>
            <v-btn
              :disabled="status.loading || !StatusUI.buttonBaslat"
              color="info"
              @click="MuhasebeEntegrasyon(1)"
              >Ön İzleme
            </v-btn>

            <v-btn
              :disabled="status.loading || !StatusUI.buttonBaslat"
              color="info"
              @click="MuhasebeEntegrasyon(0)"
              >Entegre Yap</v-btn
            >

            <v-btn
              :disabled="status.loading || !StatusUI.buttonBaslat"
              color="warning"
              @click="MuhasebeEntegrasyon(2)"
            >
              Entegre Kaldır</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout v-if="StatusUI.buttonYenile">
      <v-flex xs12 sm6 offset-sm3>
        <v-card>
          <v-card-title primary-title>
            <div>
              <h3
                v-if="StatusUI.parametre.EntegreKaldir === true"
                class="headline mb-0"
              >
                Entegrasyon Kaldırılıyor
              </h3>
              <h3
                v-else-if="StatusUI.parametre.Onizleme === true"
                class="headline mb-0"
              >
                Ön İzleme Hazırlanıyor
              </h3>

              <h3 v-else class="headline mb-0">Entegrasyon Yapılıyor</h3>

              <div>
                {{ $t("Commencement-Period") }} :
                {{ StatusUI.parametre.Tarih1 }}
              </div>
              <div>
                {{ $t("Termination-Period") }} : {{ StatusUI.parametre.Tarih2 }}
              </div>
              <div>{{ StatusUI.aciklama }}</div>

              <div></div>
              <v-progress-linear color="green" v-model="yuzde" height="25">
                <strong>{{ Math.ceil(yuzde) }}%</strong>
              </v-progress-linear>
            </div>
          </v-card-title>

          <v-card-actions>
            <v-btn
              :disabled="status.loading || !StatusUI.buttonYenile"
              color="info"
              @click="yenile(10)"
              >({{ countDown }}) Yenile</v-btn
            >

            <v-btn
              :disabled="status.loading || !StatusUI.buttonYenile"
              color="warning"
              @click="sonlandir()"
              >sonlandir
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout v-if="StatusUI.buttonIndir">
      <v-flex xs12 sm6 offset-sm3>
        <v-card>
          <v-card-title primary-title>
            <div>
              <h3
                v-if="StatusUI.parametre.EntegreKaldir === true"
                class="headline mb-0"
              >
                Entegrasyon <span style="color: red"> Kaldırıldı</span>
              </h3>
              <h3
                v-else-if="StatusUI.parametre.Onizleme === true"
                class="headline mb-0"
              >
                Ön İzleme Hazırlandı.
              </h3>
              <h3 v-else class="headline mb-0">Entegrasyon Yapıldı.</h3>
              <div>
                {{ $t("Commencement-Period") }} :
                {{ StatusUI.parametre.Tarih1 }}
              </div>
              <div>
                {{ $t("Termination-Period") }} : {{ StatusUI.parametre.Tarih2 }}
              </div>

              <table>
                <tr class="satirBaslik">
                  <th class="thStr" width='120'>Fatura Tipi </th>
                  <th class="thCur" width='100'>Fatura Sayisi </th>
                  <th class="thCur" width='100'>Borç </th>
                  <th class="thCur" width='100'>Alacak </th>
                </tr>
                <tr v-for="(d, index2) in StatusUI.sonuc.FisToplamlari">
                  <td class="thlStr">{{ FaturaTipToStr(d.FaturaTip) }}</td>
                  <td class="thlCur">{{ d.FisSayisi }}</td>
                  <td class="thlCur">{{ d.TotalDept }}</td>
                  <td class="thlCur">{{ d.TotalCredit }}</td>
                </tr>
                <tr>
                  <th class="thd">Toplam :</th>
                  <td class="thdCur">{{ StatusUI.sonuc.ToplamCount }}</td>
                  <td class="thdCur">{{ StatusUI.sonuc.TotalDept }}</td>
                  <td class="thdCur">{{ StatusUI.sonuc.TotalCredit }}</td>
                </tr>
              </table>


              <div>Entegrasyon süresi : {{ StatusUI.sonuc.Sure_dk }} dk.</div>
            </div>
          </v-card-title>

          <v-card-actions>
            <v-btn
              :disabled="status.loading || !StatusUI.buttonIndir"
              color="info"
              @click="dosyaIndir()"
              >{{ $t("Download-File-v2") }}</v-btn
            >

            <v-btn
              :disabled="status.loading || !StatusUI.buttonIndir"
              color="warning"
              @click="sil()"
            >
              Yeni aktarım Yapmak/Kaldırmak için tıklayınız.
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <div v-if="!(status.loading || !StatusUI.buttonIndir)">
      <table>
        <tr>
          <td class="baslik" colspan="6">
            ENTEGRASYON FİŞLERİ (ÖNİZLEME) - İLK 100 KAYIT
          </td>
        </tr>
        <template v-for="(m, index1) in StatusUI.sonuc.Reciepts">
          <tr>
            <th class="grupbaslik" colspan="6">
              Fiş No : {{ m.RecieptNumber }}
            </th>
          </tr>

          <tr class="parametre">
            <th class="parametread" colspan="2">Fiş Tarihi :</th>
            <td class="parametredeger" colspan="4">{{ m.RecieptDate }}</td>
          </tr>
          <tr class="parametre">
            <th class="parametread" colspan="2">Fiş Açıklama :</th>
            <td class="parametredeger" colspan="4">{{ m.RecieptTitle }}</td>
          </tr>

          <tr class="satirBaslik">
            <th class="thInt">SiraNo</th>
            <th class="thStr">Muhasebe Kodu</th>
            <th class="thStr">Muhasebe Adı</th>
            <th class="thStr">Açıklama</th>
            <th class="thCur">Borç</th>
            <th class="thCur">Alacak</th>
          </tr>
          <tr v-for="(d, index2) in m.Lines">
            <td class="thlInt">{{ d.LineNumber }}</td>
            <td class="thlStr">{{ d.AccountingCode.Code }}</td>
            <td class="thlStr">{{ d.AccountingCode.CodeName }}</td>
            <td class="thlStr">{{ d.Explanation1 }}</td>
            <td class="thlCur" v-if="d.DeptCredit == false">
              {{ d.LinePrice }}
            </td>
            <td class="thlCur" v-else>0</td>
            <td class="thlCur" v-if="d.DeptCredit == true">
              {{ d.LinePrice }}
            </td>
            <td class="thlCur" v-else>0</td>
          </tr>
          <tr>
            <th class="thd" colspan="4">Toplam :</th>
            <td class="thdCur">{{ m.TotalDept }}</td>
            <td class="thdCur">{{ m.TotalCredit }}</td>
          </tr>
        </template>
      </table>
    </div>

    <customdialog
      v-model="DialogSaticiTip"
      maxWidth="1050"
      title="Parametreler"
      :cardtextstyle="'height: 550px;'"
    >
      <div>
        <br />
        <v-toolbar flat color="white">
          <tarihcomp
            etiket="Muhaebe Dönem Tarihi"
            :detaygizle="false"
            v-model="CoperEntListPrm.CompanyPeriodDate"
            v-bind:defaultvalue="'ok'"
            :rules="[(v) => !!v || $t('Please-select-a-date')]"
          ></tarihcomp>

          <v-radio-group v-model="CoperEntListPrm.YurtDisi" row>
            <v-radio label="Yurtiçi" :value="0"></v-radio>
            <v-radio label="Yurtdışı" :value="1"></v-radio>
          </v-radio-group>

          <v-select
            v-model="CoperEntListPrm.SaticiTipi"
            :items="itemsaticitip"
            item-text="Aciklama"
            item-value="Kod"
            :label="$t('Seller-Type')"
          >
          </v-select>

          <v-select
            v-model="CoperEntListPrm.AccountingCodeType"
            :items="itemAccountingCodeType"
            item-text="Aciklama"
            item-value="Kod"
            label="Hesap Kodu Tipi"
          >
          </v-select>

          <v-select
            v-model="CoperEntListPrm.KDV"
            :items="itemKDV"
            item-text="Aciklama"
            item-value="Kod"
            label="KDV"
          >
          </v-select>

          <v-btn color="primary" @click="EntParInitialize()">Ara</v-btn>
          <v-spacer></v-spacer>

          <v-dialog v-model="EntPar.dialog" max-width="500px">
            <v-card>
              <v-card-title>
                <span class="headline">Düzenle</span>
              </v-card-title>

              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12>
                      <catimuhasebekodu
                        ref="muhasebekodu"
                        v-model="EntPar.editedItem.AccountingCode"
                        :value="EntPar.editedItem.AccountingCode"
                        :Coper="true"
                        :companyID="credentials.CoperSirketNo"
                        :text="$t('Accounting-Code')"
                      >
                      </catimuhasebekodu>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn color="blue darken-1" flat @click="Uygula(false, EntPar)"
                  >Uygula</v-btn
                >
                <v-btn color="blue darken-1" flat @click="Uygula(true, EntPar)"
                  >Seçilenlere Uygula</v-btn
                >
                <v-btn color="red darken-1" flat @click="Close(EntPar)"
                  >İptal</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
        <v-data-table
          v-model="EntPar.tbl_selected"
          select-all
          item-key="ID"
          :headers="EntPar.headers"
          :items="EntPar.desserts"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <td>
              <v-checkbox
                :input-value="props.selected"
                @change="TableItemSelected(EntPar, props.item)"
                primary
                hide-details
              ></v-checkbox>
            </td>

            <td>{{ props.item.SaticiTipi }}</td>
            <td>{{ props.item.KDV }}</td>
            <td>
              {{ props.item.AccountingCode.Code }} -
              {{ props.item.AccountingCode.CodeName }}
            </td>
            <td class="justify-center layout px-0">
              <v-btn
                flat
                icon
                color="primary"
                @click="EditItem(EntPar, props.item)"
              >
                <v-icon small class="mr-2"> edit </v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </div>

      <template slot="btn">
        <v-btn color="primary" flat @click.native="Kaydet()">Kaydet</v-btn>
      </template>
    </customdialog>

    <customdialog
      v-model="DialogSaticiKod"
      maxWidth="1050"
      title="Parametreler"
      :cardtextstyle="'height: 550px;'"
    >
      <div>
        <br />
        <v-toolbar flat color="white">
          <tarihcomp
            etiket="Muhaebe Dönem Tarihi"
            :detaygizle="false"
            v-model="CoperEntListSaticiKodPrm.CompanyPeriodDate"
            v-bind:defaultvalue="'ok'"
            :rules="[(v) => !!v || $t('Please-select-a-date')]"
          ></tarihcomp>

          <saticiara
            ref="saticiara"
            v-model="CoperEntListSaticiKodPrm.Satici"
            :tip="CoperEntListSaticiKodPrm.SaticiTipi"
            @setSeller="setSaticiTip($event)"
          ></saticiara>

          <v-select
            v-model="CoperEntListSaticiKodPrm.AccountingCodeType"
            :items="itemAccountingCodeType"
            item-text="Aciklama"
            item-value="Kod"
            label="Hesap Kodu Tipi"
          >
          </v-select>

          <v-select
            v-model="CoperEntListSaticiKodPrm.KDV"
            :items="itemKDV"
            item-text="Aciklama"
            item-value="Kod"
            label="KDV"
          >
          </v-select>

          <v-btn color="primary" @click="EntParSaticiKodInitialize()"
            >Ara</v-btn
          >
          <v-spacer></v-spacer>

          <v-dialog v-model="EntParSaticiKod.dialog" max-width="500px">
            <v-card>
              <v-card-title>
                <span class="headline">Düzenle</span>
              </v-card-title>

              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12>
                      <catimuhasebekodu
                        ref="muhasebekoduSaticiKod"
                        v-model="EntParSaticiKod.editedItem.AccountingCode"
                        :value="EntParSaticiKod.editedItem.AccountingCode"
                        :Coper="true"
                        :companyID="credentials.CoperSirketNo"
                        :text="$t('Accounting-Code')"
                      >
                      </catimuhasebekodu>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  flat
                  @click="Uygula(false, EntParSaticiKod)"
                  >Uygula</v-btn
                >
                <v-btn
                  color="blue darken-1"
                  flat
                  @click="Uygula(true, EntParSaticiKod)"
                  >Seçilenlere Uygula</v-btn
                >
                <v-btn color="red darken-1" flat @click="Close(EntParSaticiKod)"
                  >İptal</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
        <v-data-table
          v-model="EntParSaticiKod.tbl_selected"
          select-all
          item-key="ID"
          :headers="EntParSaticiKod.headers"
          :items="EntParSaticiKod.desserts"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <td>
              <v-checkbox
                :input-value="props.selected"
                @change="TableItemSelected(EntParSaticiKod, props.item)"
                primary
                hide-details
              ></v-checkbox>
            </td>
            <td>{{ props.item.SaticiTipi }}</td>
            <td>{{ props.item.KDV }}</td>
            <td>
              {{ props.item.AccountingCode.Code }} -
              {{ props.item.AccountingCode.CodeName }}
            </td>
            <td class="justify-center layout px-0">
              <v-btn
                flat
                icon
                color="primary"
                @click="EditItem(EntParSaticiKod, props.item)"
              >
                <v-icon small class="mr-2"> edit </v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </div>

      <template slot="btn">
        <v-btn color="primary" flat @click.native="KaydetSaticiKod()"
          >Kaydet</v-btn
        >
      </template>
    </customdialog>
    <confirm ref="confirm"></confirm>

  </basepage>
  
</template>

<script>
import basepage from "@/components/app/coper/comp/basepage.vue";
import tool from "@/components/app/coper/tools.js";
import tarihcomp from "@/components/app/customcomp/tarihim";
import customdialog from "@/components/app/coper/comp/customdialog.vue";
import hesapkodu from "@/components/app/muhasebe/comp/hesapkodu.vue";
import catimuhasebekodu from "@/components/app/muhasebe/comp/catimuhasebekodu.vue";
import saticiara from "@/components/app/coper/comp/saticiara.vue";
import merkez from "@/components/app/muhasebe/comp/merkez.vue";
import fistipi from "@/components/app/muhasebe/comp/fistipi.vue";
import confirm from "@/components/app/coper/comp/confirm.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp"
import genelarama from "@/components/app/coper/comp/genelarama.vue";
import helpers from "@/components/app/customcomp/helpers.js";
export default {
  components: {
    basepage,
    tarihcomp,
    customdialog,
    hesapkodu,
    catimuhasebekodu,
    saticiara,
    merkez,
    fistipi,
    confirm,
    genelarama,
  },
  data() {
    return {
    
      loaded:false,
      snackbar:false,
      text1:'',
      seciliCariFirma:null,
      seciliMuhasebeFirma:null,
      status: tool.NewSatatus(),
      countDown: 10,
      MaxCountDown: 10,
      credentials: JSON.parse(window.localStorage.getItem("credentials")),

      CoperEntListPrm: {
        CompanyPeriodDate: tool.Now_yyyy_MM_dd(),
        ID: null,
        SaticiTipi: 0,
        YurtDisi: 0,
        KDV: null,
        AccountingCodeType: 1,
        AccountingCodeID: null,
      },

      CoperEntListSaticiKodPrm: {
        CompanyPeriodDate: tool.Now_yyyy_MM_dd(),
        ID: null,
        SaticiTipi: 0,
        SaticiKodu: null,
        KDV: null,
        AccountingCodeType: 1,
        AccountingCodeID: null,
        Satici: { kod: "" },
      },

      itemKDV: [
        { Aciklama: "", Kod: null },
        { Aciklama: "0", Kod: 0 },
        { Aciklama: "1", Kod: 1 },
        { Aciklama: "8", Kod: 8 },
        { Aciklama: "10", Kod: 10 },
        { Aciklama: "18", Kod: 18 },
        { Aciklama: "20", Kod: 20 },
      ],

      itemAccountingCodeType: [
        { Aciklama: "Satış Futurası", Kod: 1 },
        { Aciklama: "Komisyon Faturası", Kod: 2 },
        { Aciklama: "Iade Faturası", Kod: 3 },
        { Aciklama: "Gelen Fatura", Kod: 4 },
        { Aciklama: "Satış Iade Faturası", Kod: 5 },
        { Aciklama: "KDV Hesabı-Kesilen", Kod: 6 },
        { Aciklama: "KDV Hesabı-Gelen", Kod: 8 },
        { Aciklama: "Iskonto Hesabı", Kod: 7 },
      ],

      itemsaticitip: [
        { Aciklama: "", Kod: 0 },
        { Aciklama: "Otel", Kod: 1 },
        { Aciklama: "Arac", Kod: 2 },
        { Aciklama: "Restaurant", Kod: 3 },
        { Aciklama: "Acente", Kod: 4 },
        { Aciklama: "RentACar", Kod: 5 },
        { Aciklama: "Rehber", Kod: 6 },
        { Aciklama: "Muze", Kod: 7 },
        { Aciklama: "Charter", Kod: 8 },
        { Aciklama: "Gemi", Kod: 9 },
        { Aciklama: "Diger", Kod: 10 },
        { Aciklama: "Vize", Kod: 11 },
        { Aciklama: "TurOperatoru", Kod: 12 },
        { Aciklama: "Sigorta", Kod: 14 },
        { Aciklama: "Feribot", Kod: 15 },
        { Aciklama: "Golf", Kod: 16 },
      ],

      CenterCode: null,
      RecieptType: null,

      EntPar: {
        tbl_selected: [],
        Accouting: null,
        KDV: null,

        AccountingCodeType: 1,

        SaticiTipi: 0,

        IcDis: 0,
        dialog: false,
        headers: [
          { text: "SaticiTipi", value: "SaticiTipi" },
          { text: "KDV", value: "KDV" },
          { text: "AccountingCode", value: "AccountingCode.CodeName" },
          { text: "Actions", value: "name", sortable: false },
        ],
        desserts: [],
        editedIndex: -1,
        editedItem: {
          name: "",
          calories: 0,
          fat: 0,
          carbs: 0,
          protein: 0,
        },
        defaultItem: {
          name: "",
          calories: 0,
          fat: 0,
          carbs: 0,
          protein: 0,
        },
      },

      EntParSaticiKod: {
        tbl_selected: [],
        Accouting: null,
        KDV: null,

        AccountingCodeType: 1,

        SaticiTipi: 0,

        IcDis: 0,
        dialog: false,
        headers: [
          { text: "SaticiTipi", value: "SaticiTipi" },
          { text: "KDV", value: "KDV" },
          { text: "AccountingCode", value: "AccountingCode.CodeName" },
          { text: "Actions", value: "name", sortable: false },
        ],
        desserts: [],
        editedIndex: -1,
        editedItem: {
          name: "",
          calories: 0,
          fat: 0,
          carbs: 0,
          protein: 0,
        },
        defaultItem: {
          name: "",
          calories: 0,
          fat: 0,
          carbs: 0,
          protein: 0,
        },
      },

      StatusUI: {
        buttonIndir: false,
        buttonBaslat: false,
        buttonYenile: false,
        TblTask: {},
      },

      yuzde: 0,
      prm: {
        Tarih1: tool.Now_yyyy_MM_dd(),
        Tarih2: tool.Now_yyyy_MM_dd(),
    
        FaturaTipleri: {
          Satis: true,
          Komisyon: false,
          Iade: false,
          Gelen: false,
          SatisIadesi: false,
        },
        Sonlandir: false,
        MasrafMerkezi:"",
      },
      MasrafMerkezi:"",
      DialogSaticiTip: false,
      DialogSaticiKod: false,

      response: [],

      aranacak: "",
      menuItems: [
        {
          title: "Satıcı Tip Parametreleri",
        },
        {
          title: "Satıcı Kod Parametreleri",
        },
      ],
    };
  },
  computed: {},

  watch: {
   
    "CoperEntListPrm.CompanyPeriodDate": function (val) {
      this.$refs.muhasebekodu.getList(val);
    },
    "CoperEntListSaticiKodPrm.CompanyPeriodDate": function (val) {
      this.$refs.muhasebekoduSaticiKod.getList(val);
    },
  },

  methods: {
    up (){
      if (this.loaded)
      {
        this.$refs.merkezcmp.coperDate=this.prm.Tarih1; 
        this.$refs.merkezcmp.getList();
      }
      else
      {
        this.loaded=true;
      }
    
      
      
    },
    TableItemSelected(EntPar, val) {
      var item = EntPar.tbl_selected.findIndex((x) => x == val);
      if (item == -1) {
        EntPar.tbl_selected.push(val);
      } else {
        EntPar.tbl_selected.splice(item, 1);
      }
    },

    EntParInitialize() {
      this.GetCoperEntList(300);
    },

    EntParSaticiKodInitialize() {
      this.GetCoperEntSaticiKodList(300);
    },

    setSaticiTip(val) {
      this.CoperEntListSaticiKodPrm.SaticiTipi = val;
    },

    EditItem(EntPar, item) {
      EntPar.editedIndex = EntPar.desserts.indexOf(item);
      EntPar.editedItem = Object.assign({}, item);
      EntPar.dialog = true;
    },

    Close(EntPar) {
      EntPar.dialog = false;
      setTimeout(() => {
        EntPar.editedItem = Object.assign({}, EntPar.defaultItem);
        EntPar.editedIndex = -1;
      }, 300);
    },

    ItemSave(EntPar, All) {
      if (EntPar.editedIndex > -1) {
        if (All == false) {
          EntPar.editedItem.isEdit = true;
          if (EntPar.editedItem.AccountingCode == undefined) {
            EntPar.editedItem.AccountingCode = {};
          }

          Object.assign(EntPar.desserts[EntPar.editedIndex], EntPar.editedItem);
        } else {
          EntPar.desserts.forEach((element) => {
            let i = EntPar.tbl_selected
              .map(function (e) {
                return e.ID;
              })
              .indexOf(element.ID);
            if (i >= 0) {
              element.isEdit = true;
              element.AccountingCode = EntPar.editedItem.AccountingCode;
            }
          });
        }
      } else {
        EntPar.desserts.push(EntPar.editedItem);
      }
    },

    FaturaTipToStr(Tip) {
      if (Tip == 1) {
        return "Satış";
      } else if (Tip == 2) {
        return "Komisyon";
      } else if (Tip == 3) {
        return "Iade";
      } else if (Tip == 4) {
        return "Gelen";
      } else if (Tip == 5) {
        return "SatisIadesi";
      } else {
        return Tip;
      }
    },

    Uygula(All, EntPar) {
      this.ItemSave(EntPar, All);
      this.Close(EntPar);
    },

    //----------------------
    countDownTimer() {
      setTimeout(() => {
        if (this.StatusUI.buttonYenile == true) {
          this.countDown -= 1;
          if (this.countDown <= 0) {
            this.MaxCountDown++;
            this.countDown = this.MaxCountDown;
            this.yenile(10);
          }
        }
        this.countDownTimer();
      }, 1000);
    },
    menuClick(index) {
      if (index == 0) {
        this.DialogSaticiTip = true;
      }
      if (index == 1) {
        this.DialogSaticiKod = true;
      }
    },
    kayitgetir() {},
    edfeterexport: edfeterexport,
    MuhasebeEntegrasyon: MuhasebeEntegrasyon,
    dosyaIndir: dosyaIndir,
    sonlandir: sonlandir,

    sil: sil,

    yenile: yenile,
    GetCoperEntList: GetCoperEntList,
    GetCoperEntSaticiKodList: GetCoperEntSaticiKodList,

    Kaydet: Kaydet,
    KaydetSaticiKod: KaydetSaticiKod,
  },

  beforeMount: beforeMount,
};

function beforeMount() {
  this.sayfayetki = helpers.pageScreenAuth(this.$route.name);
   
    if (this.sayfayetki.Status == true) {
      this.yenile(10);
      this.countDownTimer();
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;

              window.open(url, "_self");
            } else {
              var mainUrl = "#/";
              window.open(mainUrl, "_self");
            }
          }
        });
    }
 
   
}

function yenile(milisaniye) {
  this.countDown = this.MaxCountDown;
  this.status.loading = true;
  setTimeout(() => {
    var prm = {};
    tool.api_post(this, "Coper/MuhasebeEntegrasyonStatus", prm).then(
      (response) => {
        this.status.loading = false;
        if (response.body.Status == true) {
          this.StatusUI = response.body.data;

          if (response.body.data.TblTask != null) {
            this.yuzde = response.body.data.TblTask.Value;
          }
        } else {
          this.status.text = response.body.ErrorList[0];
          this.status.show = true;
        }
      },
      (response) => {
        this.status = tool.responseToStatus(response);
      }
    );
  }, milisaniye);
  
}

function GetCoperEntList(milisaniye) {
  this.status.loading = true;
  setTimeout(() => {
    tool.api_post(this, "Coper/CoperEntList", this.CoperEntListPrm).then(
      (response) => {
        this.status.loading = false;
        if (response.body.Status == true) {
          this.EntPar.tbl_selected = [];
          this.EntPar.desserts = response.body.data;
        } else {
          this.status.text = response.body.ErrorList[0];
          this.status.show = true;
        }
      },
      (response) => {
        this.status = tool.responseToStatus(response);
      }
    );
  }, milisaniye);
}

function GetCoperEntSaticiKodList(milisaniye) {
  this.status.loading = true;

  if (
    this.CoperEntListSaticiKodPrm.Satici !== null &&
    this.CoperEntListSaticiKodPrm.Satici.kod != undefined
  ) {
    this.CoperEntListSaticiKodPrm.SaticiKodu =
      this.CoperEntListSaticiKodPrm.Satici.kod;
  }
  setTimeout(() => {
    tool
      .api_post(
        this,
        "Coper/CoperEntSaticiKodList",
        this.CoperEntListSaticiKodPrm
      )
      .then(
        (response) => {
          this.status.loading = false;
          if (response.body.Status == true) {
            this.EntParSaticiKod.tbl_selected = [];
            this.EntParSaticiKod.desserts = response.body.data;
          } else {
            this.status.text = response.body.ErrorList[0];
            this.status.show = true;
          }
        },
        (response) => {
          this.status = tool.responseToStatus(response);
        }
      );
  }, milisaniye);
}

function Kaydet() {
  this.status.loading = true;

  let prm = {
    IDList: [],
  };

  this.EntPar.desserts.forEach((element) => {
    if (element.isEdit === true) {
      let prmItem = {
        AccountingCodeID: element.AccountingCode.CodeID,
        ID: element.ID,
      };
      prm.IDList.push(prmItem);
    }
  });

  setTimeout(() => {
    tool.api_post(this, "Coper/CoperEntUpdate", prm).then(
      (response) => {
        this.status.loading = false;

        if (response.body.Status == true) {
          this.EntPar.desserts.forEach((element) => {
            if (element.isEdit === true) {
              element.isEdit = false;
            }
          });
        } else {
          this.status.text = response.body.ErrorList[0];
          this.status.show = true;
        }
      },
      (response) => {
        this.status = tool.responseToStatus(response);
      }
    );
  }, 100);
}

function KaydetSaticiKod() {
  this.status.loading = true;

  let prm = {
    IDList: [],
  };

  this.EntParSaticiKod.desserts.forEach((element) => {
    if (element.isEdit === true) {
      let prmItem = {
        AccountingCodeID: element.AccountingCode.CodeID,
        ID: element.ID,
      };
      prm.IDList.push(prmItem);
    }
  });

  setTimeout(() => {
    tool.api_post(this, "Coper/CoperEntSaticiKodUpdate", prm).then(
      (response) => {
        this.status.loading = false;
        if (response.body.Status == true) {
          this.EntPar.desserts.forEach((element) => {
            if (element.isEdit === true) {
              element.isEdit = false;
            }
          });
        } else {
          this.status.text = response.body.ErrorList[0];
          this.status.show = true;
        }
      },
      (response) => {
        this.status = tool.responseToStatus(response);
      }
    );
  }, 100);
}

function dosyaIndir() {
  var prm = {};

  this.status.loading = true;
  setTimeout(() => {
    tool.api_post_FileDownload(this, "EDefter/MuhasebeFisiIndir", prm).then(
      (response) => {
        tool.CreateDownloadLink(response, "muhasebefisi");
        this.status.text = "Dosya İndiriliyor";
        this.status.show = true;
        this.status.loading = false;
      },
      (response) => {
        this.status = tool.responseToStatus(response);
      }
    );
  }, 5000);
}



function MuhasebeEntegrasyon(Islem)
{

  if (this.CenterCode == null) {
    this.status.text = "Lütfen merkez seçimi yapınız.";
    this.status.show = true;
    return;
  }

  if (this.RecieptType == null) {
    this.status.text = "Lütfen Fiş Tipi seçimi yapınız.";
    this.status.show = true;
    return;
  }

  if(Islem == 1){
    this.$refs.confirm.open("Fiş Ön izleme", "Ön izleme işleminde Muhasebeye kayıt atılmayacaktır" , {
      color: "red",
      message: ""
     
    })
    .then(confirm => {
      if (confirm == true) {
        this.edfeterexport(Islem)
      }
    });
  }
  else if(Islem==2)
  {
    this.$refs.confirm.open("Fiş Kaldır", "Entegrasyonu kaldırmayı onaylıyor musunuz?" , {
      color: "red",
      message: "Entegrasyonu kaldırmayı onaylıyorum."
    })
    .then(confirm => {
      if (confirm == true) {
        this.edfeterexport(Islem)
      }
    });
  }else{
     this.$refs.confirm.open("Fiş Oluştur", "Muhasebeye kayıt atılmasını onaylıyor musunuz?" , {
      color: "red",
      message: "Muhasebeye kayıt atılmasını onaylıyorum."
    })
    .then(confirm => {
      if (confirm == true) {
        this.edfeterexport(Islem)
      }
    });
  }


}


function edfeterexport(Islem) {
  let prm = this.prm;

  prm.Onizleme = false;
  prm.EntegreKaldir = false;
  prm.MasrafMerkezi=this.MasrafMerkezi.kod;

  if (Islem == 1) {
    prm.Onizleme = true;
  } else if (Islem == 2) {
    prm.EntegreKaldir = true;
  }

  prm.Sonlandir = false;
  prm.Sil = false;
  prm.CenterID = this.CenterCode.ID;
  prm.RecieptTypeID = this.RecieptType.ID;
 
  this.status.loading = true;
  tool.api_post(this, "Coper/MuhasebeEntegrasyon", prm).then(
    (response) => {
      this.status.loading = false;
      this.response = response.body;

      if (response.body.Status == true) {
        //this.status.text = response.body.Message;
        //this.status.show = true;
        //this.yuzde = 0;

        this.MaxCountDown = 10;
        this.yenile(5000);
      } else {
        this.status.text = response.body.ErrorList[0];
        this.status.show = true;

        if (response.body.TaskInfo != null) {
          if (response.body.TaskInfo.Status == 2) {
            //Devam ediyor
            this.yuzde = response.body.TaskInfo.Value;
          }
          if (response.body.TaskInfo.Status == 3) {
            //Tamamlandı
            this.yuzde = response.body.TaskInfo.Value;
          }
        }
      }
    },
    (response) => {
      this.status = tool.responseToStatus(response);
    }
  );
}

function sonlandir() {
  let prm = this.prm;
  prm.Sonlandir = true;
  prm.Sil = false;

  prm.MasrafMerkezi=this.MasrafMerkezi.kod;

  this.status.loading = true;
  tool.api_post(this, "Coper/MuhasebeEntegrasyon", prm).then(
    (response) => {
      this.status.loading = false;
      if (response.body.Status == true) {
        this.status.text = response.body.Message;
        this.status.show = true;
      } else {
        this.status.text = response.body.ErrorList[0];
        this.status.show = true;
      }
      this.StatusUI = response.body.TaskInfoUI;
    },
    (response) => {
      this.status = tool.responseToStatus(response);
    }
  );
}

function sil() {
  let prm = this.prm;
  prm.Sonlandir = false;
  prm.Sil = true;
  prm.MasrafMerkezi=this.MasrafMerkezi.kod;

  this.status.loading = true;
  tool.api_post(this, "Coper/MuhasebeEntegrasyon", prm).then(
    (response) => {
      this.status.loading = false;
      if (response.body.Status == true) {
        this.status.text = response.body.Message;
        this.status.show = true;
      } else {
        this.status.text = response.body.ErrorList[0];
        this.status.show = true;
      }
      this.StatusUI = response.body.TaskInfoUI;
    },
    (response) => {
      this.status = tool.responseToStatus(response);
    }
  );
}
</script>

<style scoped>
table {
  border-collapse: collapse;
  width: 100%;
}

th,
td {
  text-align: left;
  padding: 2px;
  border-bottom: 1px solid #ddd;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
}
.ustlogo {
  display: block;
  margin-left: auto;
  margin-right: auto;
  height: 100px;
}

.parametread {
  text-align: right;
}

.parametredeger {
  text-align: left;
}

.baslik {
  text-align: center;
  background-color: #b0e9f4;
  font-size: 18pt;
  color: #362edd;
  font-weight: bold;
}

.grupbaslik {
  text-align: left;
  color: #c60303;
}

.thInt,
.thStr,
.thDate {
  background-color: #b0e9f4;
}

.thCur {
  text-align: right;
  background-color: #b0e9f4;
}

.thlInt,
.thlStr,
.thlDate {
}

.thlCur {
  text-align: right;
}

.thd {
  text-align: right;
  color: #362edd;
}

.thdCur {
  text-align: right;
  color: #362edd;
}

.thg {
  text-align: right;
  color: #c60303;
}

.thgCur {
  text-align: right;
  color: #c60303;
}
</style>
